import { ViewProps } from './vocabulary.constants';
import * as Styled from './vocabulary-print.style';

const VocabularyPrint = ({ vocabularyDefinitions }: ViewProps) => {
  return (
    <>
      <Styled.VocabularyTitle>Vocabulary</Styled.VocabularyTitle>
      <Styled.VocabularyList>
        {vocabularyDefinitions?.map((definition, index) => (
          <Styled.VocabularyListItem key={index}>
            <Styled.VocabularyStaticButton>
              {definition.word}
            </Styled.VocabularyStaticButton>
          </Styled.VocabularyListItem>
        ))}
      </Styled.VocabularyList>
    </>
  );
};

export default VocabularyPrint;
